const actions = {
  SET_STATE: 'business-type/SET_STATE',

  LOAD_ALL: 'business-type/LOAD_ALL',
}

export default actions
